import sentpaymentCheckQuickformHtml from './sentpayment-check-quickform.html'

const dbRequest = require('../../../../../js-network/db-request')
const dtHandler = require('../../../../../components/dt/dt-handler')
const quickform = require('../../../../../components/quickform/quickform')
const quickformHandler = require('../../../../../components/quickform/quickform-handler')
const sentpaymentDialog = require('./sentpayment-dialog')
const sentpaymentDt = require('./sentpayment-dt')
const sentpaymentReport = require('./sentpayment-report')

const allowedFormats = [
  'one_check_per_page',
  'one_check_with_void',
  'three_checks_per_page',
]
const checkTableColumns = [
  { key: 'provider_name', label: 'Provider', behavior: false, displayText: true },
  { key: 'accounts_name', label: 'From Account', behavior: false, displayText: true },
  { key: 'amount_dt', label: 'Amount', behavior: false, displayText: true },
]

let htmlQf = {}
let HTMLwasSelected = false
let selectedIds = []
let afterMarkedCallback
let printing = false

function HTMLselect() {
  quickformHandler.HTMLselect(
    'sentpayment',
    'sentpayment-check-quickform',
    null,
    sentpaymentCheckQuickformHtml,
    undefined,
    undefined,
    htmlQf
  )

  HTMLwasSelected = true
}

export function start(detail) {
  if (!HTMLwasSelected) { HTMLselect() }
  obj[detail.act].start(detail)
}

const obj = {
  finishWithoutMark: { start: () => { resetSelection() } },
  hide: { start: () => { hide() } },
  markPrinted: { start: (detail) => { markPrinted(detail) } },
  preparePrint: { start: (detail) => { preparePrint(detail) } },
  printChecks: { start: () => { printChecks() } },
}

function resetSelection() {
  selectedIds = []
  afterMarkedCallback = undefined
}

function normalizeIds(ids) {
  const values = Array.isArray(ids) ? ids : [ids]

  return [...new Set(values
    .map((id) => Number.parseInt(String(id).replace(/[^0-9]/g, ''), 10))
    .filter((id) => Number.isInteger(id) && id > 0))]
}

function escapeHtml(value) {
  const div = document.createElement('div')
  div.textContent = String(value ?? '')
  return div.innerHTML
}

function renderRows(rows) {
  const container = htmlQf.quickformHTML.querySelector('#sentpayment-check-print-table')
  const safeRows = rows.map((row) => ({
    provider_name: escapeHtml(row.provider_name),
    accounts_name: escapeHtml(row.accounts_name),
    amount_dt: escapeHtml(row.amount_dt),
  }))

  // Usa el componente DT Simple del framework en lugar de construir la tabla aqui.
  container.innerHTML = dtHandler.dtSimpleFc(safeRows, checkTableColumns)
}

function selectFormat(value) {
  const format = allowedFormats.includes(value) ? value : 'one_check_per_page'
  const input = htmlQf.quickformHTML.querySelector(`input[name="sentpayment-check-print-format"][value="${format}"]`)

  if (input !== null) {
    input.checked = true
  }
}

async function preparePrint(detail) {
  // El DT envia dbid como las acciones multiples del framework; las aperturas
  // individuales conservan ids para no cambiar su contrato actual.
  const ids = normalizeIds(detail.dbid ?? detail.ids)

  if (ids.length === 0) {
    sentpaymentDialog.start({ act: 'show', id: 'checkPaymentNotFound' })
    return
  }

  const requestDetail = {
    inf: {
      entity: 'sentpayment',
      ids: JSON.stringify(ids),
    },
  }
  const result = await dbRequest.start(requestDetail, 'server/php/sql/sentpaymentCheckPrintPreview.php')

  if (result.status !== 'ok') {
    sentpaymentDialog.start({ act: 'show', id: 'checkPrintError' })
    return
  }

  const rows = Array.isArray(result.data) ? result.data : []

  if (rows.length !== ids.length) {
    sentpaymentDialog.start({ act: 'show', id: 'checkPaymentNotFound' })
    return
  }

  const ineligibleRows = rows.filter((row) => row.check_generation_active !== 'true')

  if (ineligibleRows.length > 0) {
    sentpaymentDialog.start({
      act: 'show',
      id: 'checkGenerationDisabled',
      payments: ineligibleRows,
      selectedCount: rows.length,
    })
    return
  }

  selectedIds = ids
  afterMarkedCallback = detail.afterMarked
  renderRows(rows)
  selectFormat(rows[0]?.default_check_print_format)
  quickform.start({ act: 'show', html: htmlQf.quickformHTML })
}

function hide(preserveState = false) {
  quickform.start({ act: 'hide', html: htmlQf.quickformHTML })

  if (!preserveState) {
    resetSelection()
  }
}

function printChecks() {
  if (printing || selectedIds.length === 0) { return }

  const formatInput = htmlQf.quickformHTML.querySelector(
    'input[name="sentpayment-check-print-format"]:checked'
  )
  const checkFormat = formatInput?.value

  if (!allowedFormats.includes(checkFormat)) { return }

  printing = true
  sentpaymentReport.printPdf({
    id: selectedIds[0],
    ids: selectedIds,
    type: 'print',
    entity: 'sentpayment',
    report: 'sentpayment-check',
    checkFormat: checkFormat,
  }, () => {
    printing = false
    hide(true)

    // Se espera a que termine la animacion del quickform antes de abrir el dialogo.
    setTimeout(() => {
      sentpaymentDialog.start({
        act: 'show',
        id: 'checksPrintedConfirmation',
        ids: selectedIds,
      })
    }, 320)
  }, () => {
    printing = false
  })
}

async function markPrinted(detail) {
  const ids = normalizeIds(detail.ids)

  if (ids.length === 0) { return }

  const requestDetail = {
    inf: {
      entity: 'sentpayment',
      ids: JSON.stringify(ids),
    },
  }
  const result = await dbRequest.start(requestDetail, 'server/php/sql/sentpaymentMarkChecksPrinted.php')

  if (result.status !== 'ok') {
    sentpaymentDialog.start({ act: 'show', id: 'checkStatusUpdateError' })
    return
  }

  const printedRows = (Array.isArray(result.data) ? result.data : [])
    .filter((row) => row.check_status === 'Printed')

  // Actualiza solamente las lineas afectadas, sin volver a consultar el DT.
  sentpaymentDt.start({ act: 'updatePrintedRows', rows: printedRows })

  if (typeof afterMarkedCallback === 'function') {
    afterMarkedCallback({ ids: printedRows.map((row) => row.id) })
  }

  resetSelection()
}
